'use client';

// istanbul ignore file
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import { CONTAINER_MAX_WIDTH } from 'reservations/base/helpers';
import { getStyledTopMatterContainerMaxWidth } from 'reservations/booking/helpers/index';
import muiPropForwarding from 'reservations/brand/helpers/muiPropForwarding';

type StyledTopMatterContainerProps = {
  topMatterMaxWidth: string;
};

const StyledTopMatterContainer = styled(Box, {
  shouldForwardProp: muiPropForwarding('topMatterMaxWidth')
})<StyledTopMatterContainerProps>(({ theme, topMatterMaxWidth }) => ({
  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
    bottom: theme.spacing(2),
    marginBottom: 0,
    maxWidth: CONTAINER_MAX_WIDTH
  },
  [theme.breakpoints.up('md')]: {
    bottom: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    maxWidth: CONTAINER_MAX_WIDTH
  },
  margin: '0 auto',
  marginTop: '80px',
  maxWidth: topMatterMaxWidth,
  position: 'relative'
}));

type BaseTopMatterProps = {
  children?: React.ReactNode;
};

const BaseTopMatter = ({ children }: BaseTopMatterProps) => {
  const topMatterMaxWidth = getStyledTopMatterContainerMaxWidth(
    window.location.pathname,
    true
  );

  return (
    <Box id="base-top-matter-container">
      <StyledTopMatterContainer topMatterMaxWidth={topMatterMaxWidth}>
        {children}
      </StyledTopMatterContainer>
    </Box>
  );
};

export default BaseTopMatter;
